import { render, staticRenderFns } from "./ModalItemsRecebimentoErros.vue?vue&type=template&id=1e3bc866&scoped=true"
import script from "./ModalItemsRecebimentoErros.vue?vue&type=script&lang=ts"
export * from "./ModalItemsRecebimentoErros.vue?vue&type=script&lang=ts"
import style0 from "./ModalItemsRecebimentoErros.vue?vue&type=style&index=0&id=1e3bc866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3bc866",
  null
  
)

export default component.exports